import { createApp } from 'vue';
import { createPinia } from 'pinia';
import '@fontsource-variable/inter';
import '@fontsource-variable/jetbrains-mono';
import './styles/tokens.css';
import './styles/base.css';
import App from './App.vue';
import { router } from './router';

/**
 * После деплоя у открытой вкладки старые ссылки на файлы разделов: догрузить раздел не получится.
 * Перезагружаем страницу один раз — придёт новая версия. Защита от цикла — отметка в sessionStorage на минуту.
 */
function reloadForNewVersion() {
  try {
    const last = Number(sessionStorage.getItem('st-reloaded-at') || 0);
    if (Date.now() - last < 60_000) return;
    sessionStorage.setItem('st-reloaded-at', String(Date.now()));
  } catch {
    /* без sessionStorage — всё равно пробуем */
  }
  window.location.reload();
}
window.addEventListener('vite:preloadError', (e) => {
  e.preventDefault();
  reloadForNewVersion();
});
router.onError((err) => {
  const msg = err instanceof Error ? err.message : String(err);
  if (/dynamically imported module|Importing a module script failed|error loading dynamically imported module/i.test(msg)) reloadForNewVersion();
});

createApp(App).use(createPinia()).use(router).mount('#app');

// Экран загрузки (index.html) — убираем, когда первая страница готова: вход проверен, маршрут разрешён
void router.isReady().finally(() => {
  requestAnimationFrame(() => {
    const boot = document.getElementById('boot');
    if (!boot) return;
    boot.classList.add('boot--hide');
    window.setTimeout(() => boot.remove(), 320);
  });
});
